// extracted by mini-css-extract-plugin
module.exports = {"label":"_9e1425b4d3--label--fCs_v","cursor_pointer":"_9e1425b4d3--cursor_pointer--i71ok"};